import { useEffect, useRef } from 'react';

/**
 * блок скролла
 * @param isLocked
 */
export function useBodyScrollLock(isLocked: boolean) {
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    if (isLocked) {
      scrollYRef.current = window.scrollY;
      const html = document.documentElement;
      const body = document.body;

      html.classList.add('mobile-menu-open');
      body.classList.add('mobile-menu-open');
      body.style.top = `-${scrollYRef.current}px`;

      const preventScroll = (e: TouchEvent) => {
        const target = e.target as HTMLElement;
        const menu = document.querySelector('[data-mobile-menu]');
        if (menu && menu.contains(target)) {
          return;
        }
        e.preventDefault();
      };

      document.addEventListener('touchmove', preventScroll, { passive: false });

      return () => {
        html.classList.remove('mobile-menu-open');
        body.classList.remove('mobile-menu-open');
        body.style.top = '';
        window.scrollTo(0, scrollYRef.current);
        document.removeEventListener('touchmove', preventScroll);
      };
    }
  }, [isLocked]);
}
